import React from 'react';
import { MemoryRouter, Route, Switch } from 'react-router-dom';
import { StateMachineProvider } from 'little-state-machine';

import Layout from '../../components/Layout';

import Data from './01-data';
import Card from './02-card';
import Offers from './03-offers';

// import { STORE_NAME } from '../../config';
// createStore({ data: {} }, { name: STORE_NAME });

const Tarjeta = props => (
  <StateMachineProvider>
    <MemoryRouter initialEntries={['/1', '/2', '/3']} initialIndex={0}>
      <Layout>
        <Switch>
          <Route exact path="/1" component={Data} />
          <Route exact path="/2" component={Card} />
          <Route exact path="/3" component={Offers} />
        </Switch>
      </Layout>
    </MemoryRouter>
  </StateMachineProvider>
);

export default Tarjeta;
